/* eslint-disable import/extensions */

// Services Img Imports
import ManagedITServices from '../assets/images/Services/services/managed-it-services.jpg';
import DisasterRecovery from '../assets/images/Services/services/disaster-recovery.jpg';
import ProactiveCybersecurity from '../assets/images/Services/services/cybersecurity-services.jpg';
import ITConsulting from '../assets/images/Services/services/it-consulting.jpg';
import CloudSolutions from '../assets/images/Services/services/cloud-solutions.jpg';
import NetworkSecurity from '../assets/images/Services/services/network-security.jpg';
import VCioServices from '../assets/images/Services/services/vcio-services.jpg';
import HostedPrivateCloud from '../assets/images/Services/services/hosted-private-cloud.jpg';
import HardwareAsAService from '../assets/images/Services/services/hardware-as-a-service.jpg';
import ManagedPrintServices from '../assets/images/Services/services/managed-print-services.jpg';
import RoboticProcessAutomation from '../assets/images/Services/services/robotic-process-automation.jpg';

// Portfolio Img Imports
import Recruiting from '../assets/images/Portfolio/Recruiting.png';
import Stream from '../assets/images/Portfolio/Stream.png';
import Freelance from '../assets/images/Portfolio/Freelance.png';
import Aura from '../assets/images/Portfolio/Aura.png';
import Surtido from '../assets/images/Portfolio/Surtido.png';
import ManagementApp from '../assets/images/Portfolio/ManagementApp.png';

// Advantages
import Communicative from '../assets/images/Advantages/Communicative.png';
import Collaborative from '../assets/images/Advantages/Collaborative.png';
import Management from '../assets/images/Advantages/Management.png';
import Favorite from '../assets/images/Advantages/Favorite.png';

// Testimonials
import Sasha from '../assets/images/Testimonials/Sasha.jpg';
import Reiner from '../assets/images/Testimonials/Reiner.jpg';
import Kruger from '../assets/images/Testimonials/Kruger.jpg';

// TeamMembers
import CEO from '../assets/images/TeamMembers/CEO.jpg';
import HRD from '../assets/images/TeamMembers/HRD.jpg';
import Finance from '../assets/images/TeamMembers/Finance.jpg';
import ProjectManager from '../assets/images/TeamMembers/Project-manager.jpg';
import Frontend1 from '../assets/images/TeamMembers/Frontend1.jpg';
import Frontend2 from '../assets/images/TeamMembers/Frontend2.jpg';
import Backend1 from '../assets/images/TeamMembers/Backend1.jpg';
import Backend2 from '../assets/images/TeamMembers/Backend2.jpg';
import Mobile1 from '../assets/images/TeamMembers/Mobile1.jpg';
import Mobile2 from '../assets/images/TeamMembers/Mobile2.jpg';
import UIUX1 from '../assets/images/TeamMembers/UIUX1.jpg';
import UIUX2 from '../assets/images/TeamMembers/UIUX2.jpg';

export const Services = [
  {
    title: 'Managed IT Services',
    imageUrl: ManagedITServices,
    animation: 'left',
  },
  {
    title: 'Disaster Recovery',
    imageUrl: DisasterRecovery,
    animation: 'left',
  },
  {
    title: 'Cybersecurity services',
    imageUrl: ProactiveCybersecurity,
    animation: 'left',
  },
  {
    title: 'IT Consulting',
    imageUrl: ITConsulting,
    animation: 'right',
  },
  {
    title: 'Cloud Solutions',
    imageUrl: CloudSolutions,
    animation: 'right',
  },
  {
    title: 'Network Security',
    imageUrl: NetworkSecurity,
    animation: 'right',
  },
  {
    title: 'vCIO Services',
    imageUrl: VCioServices,
    animation: 'right',
  },
  {
    title: 'Hosted Private Cloud',
    imageUrl: HostedPrivateCloud,
    animation: 'right',
  },
  {
    title: 'Hardware as a Service',
    imageUrl: HardwareAsAService,
    animation: 'right',
  },
  {
    title: 'Managed Print Services',
    imageUrl: ManagedPrintServices,
    animation: 'right',
  },
  {
    title: 'Robotic Process Automation',
    imageUrl: RoboticProcessAutomation,
    animation: 'right',
  },
];

export const Portfolios = [
  {
    id: 'asd1293uasdads1',
    title: 'Recruiting App',
    imageUrl: Recruiting,
    type: 'Mobile Apps',
    responsibility: [
      'Mobile Development',
      'UI/UX Design',
    ],
    credit: 'https://dribbble.com/shots/15164950-Recruiting-app',
  },
  {
    id: 'asd1293uhjkhkjh2',
    title: 'Stream+',
    imageUrl: Stream,
    type: 'Mobile Apps',
    responsibility: [
      'Mobile Development',
      'UI/UX Design',
    ],
    credit: 'https://dribbble.com/shots/15276430-Stream',
  },
  {
    id: 'asd1293uvbvcbbd3',
    title: 'Freelance',
    imageUrl: Freelance,
    type: 'Mobile Apps',
    responsibility: [
      'Mobile Development',
      'UI/UX Design',
    ],
    credit: 'https://dribbble.com/shots/15223131-Freelance-Mobile-App-Concept',
  },
  {
    id: 'asd1293ufgdfgs4',
    title: 'Aura',
    imageUrl: Aura,
    type: 'Website',
    responsibility: [
      'Web Development',
      'UI/UX Design',
    ],
    credit: 'https://dribbble.com/shots/15176338-Aura-Website-Main-Page',
  },
  {
    id: 'asd1293ulskmnb5',
    title: 'Surtido Rico',
    imageUrl: Surtido,
    type: 'Website',
    responsibility: [
      'Web Development',
      'UI/UX Design',
    ],
    credit: 'https://dribbble.com/shots/15173118-Surtido-Rico',
  },
  {
    id: 'asd1293ulkmnbj6',
    title: 'Courses Management',
    imageUrl: ManagementApp,
    type: 'Website',
    responsibility: [
      'Web Development',
      'UI/UX Design',
    ],
    credit: 'https://dribbble.com/shots/15197890-Courses-Management-and-Promoting-Web-App',
  },
];

export const Advantages = [
  [{
    title: '5-Minute Response',
    description: "When you're a DNS Computer client, you'll get a real human response to your support needs — faster.",
    imageUrl: Communicative,
  },
  {
    title: 'Guaranteed Service',
    description: 'We stand behind all of our work for every one of our clients. No excuses, 100% of the time.',
    imageUrl: Management,
  }],
  [{
    title: 'Dedicated Client Success Manager​',
    description: 'Your Dedicated Client Success Manager ensures personalized support, proactive communication, and seamless IT solutions tailored to your business needs.',
    imageUrl: Collaborative,
  },
  {
    title: 'Favorite',
    description: "We've did so many project and all of our client love it.",
    imageUrl: Favorite,
  }],
];
export const Testimonials = [
  {
    id: 1,
    name: 'Sasha Rose',
    company: 'Owner, Surveyor Corps',
    testimoni: 'Thanks for DNS Computer, you guys are the best! Keep up the great work!',
    imageUrl: Sasha,
  },
  {
    id: 2,
    name: 'Kruger Khan',
    company: 'Director, Shultan Oil',
    testimoni: "I just wanted to let you know that it's been great working with DNS Computer.",
    imageUrl: Kruger,
  },
  {
    id: 3,
    name: 'Reiner John',
    company: 'CEO, Marley CO',
    testimoni: 'DNS Computer is so great. Thank you so much for a job well done.',
    imageUrl: Reiner,
  },
];

export const TeamMembers = [
  {
    name: 'Rach David',
    position: 'CEO',
    imageUrl: CEO,
  },
  {
    name: 'Pauline Sydney',
    position: 'HRD',
    imageUrl: HRD,
  },
  {
    name: 'Granger Watterson',
    position: 'Finance',
    imageUrl: Finance,
  },
  {
    name: 'Tom Jimmy',
    position: 'Project Manager',
    imageUrl: ProjectManager,
  },
  {
    name: 'Jim Hendrix',
    position: 'Front-end Developer',
    imageUrl: Frontend1,
  },
  {
    name: 'Calvin Max',
    position: 'Front-end Developer',
    imageUrl: Frontend2,
  },
  {
    name: 'Hawkins Jim',
    position: 'Back-end Developer',
    imageUrl: Backend1,
  },
  {
    name: 'Don Bizaro',
    position: 'Back-end Developer',
    imageUrl: Backend2,
  },
  {
    name: 'Bill Markinson',
    position: 'Mobile Developer',
    imageUrl: Mobile1,
  },
  {
    name: 'Igor Kavarov',
    position: 'Mobile Developer',
    imageUrl: Mobile2,
  },
  {
    name: 'Freddie Curl',
    position: 'UI/UX Designer',
    imageUrl: UIUX2,
  },
  {
    name: 'Monica Lovegood',
    position: 'UI/UX Designer',
    imageUrl: UIUX1,
  },
];
